import type { Abi } from 'viem'

export const UNWRAP_AND_CALL_ABI: Abi = [
  {
    name: 'unwrapAndCall',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'target', type: 'address' },
      { name: 'callData', type: 'bytes' },
    ],
    outputs: [{ name: 'returnData', type: 'bytes' }],
  },
]

export const VAULT_DEPOSITOR_ABI: Abi = [
  {
    inputs: [
      { internalType: 'address', name: 'initialOwner', type: 'address' },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint256', name: 'tickSize', type: 'uint256' },
    ],
    name: 'AmountBelowMinimumTick',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'bytes', name: 'returnData', type: 'bytes' }],
    name: 'DepositFailed',
    type: 'error',
  },
  { inputs: [], name: 'DustRefundFailed', type: 'error' },
  { inputs: [], name: 'EmptyMethodSignature', type: 'error' },
  { inputs: [], name: 'InsufficientETHAmount', type: 'error' },
  { inputs: [], name: 'InsufficientTokenAmount', type: 'error' },
  {
    inputs: [{ internalType: 'string', name: 'reason', type: 'string' }],
    name: 'InvalidCalldata',
    type: 'error',
  },
  { inputs: [], name: 'InvalidDustRecipient', type: 'error' },
  { inputs: [], name: 'InvalidFunctionSelector', type: 'error' },
  { inputs: [], name: 'InvalidTickSize', type: 'error' },
  { inputs: [], name: 'InvalidVault', type: 'error' },
  { inputs: [], name: 'NoETHInContract', type: 'error' },
  {
    inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
    name: 'OwnableInvalidOwner',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'OwnableUnauthorizedAccount',
    type: 'error',
  },
  { inputs: [], name: 'ReentrancyGuardReentrantCall', type: 'error' },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'SafeERC20FailedOperation',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'address', name: 'vault', type: 'address' },
      { internalType: 'bytes4', name: 'selector', type: 'bytes4' },
    ],
    name: 'SelectorNotAllowed',
    type: 'error',
  },
  { inputs: [], name: 'VaultAlreadyRegistered', type: 'error' },
  { inputs: [], name: 'VaultDoesNotSupportNative', type: 'error' },
  { inputs: [], name: 'VaultNotRegistered', type: 'error' },
  { inputs: [], name: 'VaultNotRegisteredForDeposit', type: 'error' },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'dust',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'originalAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'depositedAmount',
        type: 'uint256',
      },
    ],
    name: 'DustRefunded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'vault',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'returnData',
        type: 'bytes',
      },
    ],
    name: 'FunMediatedDeposit',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'vault',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'bytes4',
        name: 'newSelector',
        type: 'bytes4',
      },
    ],
    name: 'SelectorUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'vault',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'string',
        name: 'methodSignature',
        type: 'string',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'convertTo18Decimals',
        type: 'bool',
      },
    ],
    name: 'VaultRegistered',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'vault',
        type: 'address',
      },
    ],
    name: 'VaultRemoved',
    type: 'event',
  },
  {
    inputs: [],
    name: 'AMOUNT_PLACEHOLDER',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'AMOUNT_PLACEHOLDER_BYTES32',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'NATIVE_TOKEN',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint256', name: 'tickSize', type: 'uint256' },
    ],
    name: 'calculateTickRounding',
    outputs: [
      { internalType: 'uint256', name: 'roundedAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'dust', type: 'uint256' },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'address', name: 'vault', type: 'address' },
      { internalType: 'bytes', name: 'callData', type: 'bytes' },
      { internalType: 'uint256', name: 'minAmountOut', type: 'uint256' },
    ],
    name: 'deposit',
    outputs: [{ internalType: 'bytes', name: 'returnData', type: 'bytes' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'address', name: 'vault', type: 'address' },
      { internalType: 'bytes', name: 'callData', type: 'bytes' },
      { internalType: 'uint256', name: 'minAmountOut', type: 'uint256' },
      { internalType: 'uint256', name: 'tickSize', type: 'uint256' },
      { internalType: 'address', name: 'dustRecipient', type: 'address' },
    ],
    name: 'depositWithTick',
    outputs: [{ internalType: 'bytes', name: 'returnData', type: 'bytes' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
    name: 'getAllowedSelector',
    outputs: [{ internalType: 'bytes4', name: '', type: 'bytes4' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'tickSize', type: 'uint256' }],
    name: 'getMinimumDepositForTick',
    outputs: [{ internalType: 'uint256', name: 'minAmount', type: 'uint256' }],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
    name: 'getVaultConfig',
    outputs: [
      {
        components: [
          { internalType: 'bool', name: 'isRegistered', type: 'bool' },
          { internalType: 'bool', name: 'convertTo18Decimals', type: 'bool' },
          { internalType: 'bool', name: 'allowsNative', type: 'bool' },
          { internalType: 'bytes4', name: 'allowedSelector', type: 'bytes4' },
        ],
        internalType: 'struct VaultConfigLib.VaultConfig',
        name: 'config',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
    name: 'isVaultRegistered',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'vault', type: 'address' },
      { internalType: 'string', name: 'vaultABI', type: 'string' },
      {
        internalType: 'bytes4',
        name: 'allowedFunctionSelector',
        type: 'bytes4',
      },
      { internalType: 'bool', name: 'convertTo18Decimals', type: 'bool' },
      { internalType: 'bool', name: 'allowsNative', type: 'bool' },
    ],
    name: 'registerVault',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
    name: 'removeVault',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'vault', type: 'address' },
      { internalType: 'bytes4', name: 'newSelector', type: 'bytes4' },
    ],
    name: 'updateAllowedSelector',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint256', name: 'tickSize', type: 'uint256' },
    ],
    name: 'validateAmountForTick',
    outputs: [
      { internalType: 'bool', name: 'isValid', type: 'bool' },
      { internalType: 'uint256', name: 'roundedAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'dust', type: 'uint256' },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
    name: 'vaultAllowsNative',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'vaultConfigs',
    outputs: [{ internalType: 'uint40', name: '', type: 'uint40' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
    name: 'vaultRequires18Decimals',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  { stateMutability: 'payable', type: 'receive' },
]
